import { TAddress, TFormatAddressProperties } from './address.formatter.types';

export const getFormattedAddress = ({
    listingData,
}: TFormatAddressProperties): string => {
    if (!listingData) {
        return '';
    }

    const propertyAddress: TAddress = {
        line1: listingData.line1,
        line2: listingData.line2,
        town: listingData.town,
        county: listingData.county,
        postcode: listingData.postcode,
    };

    if (
        propertyAddress.line1 &&
        propertyAddress.line2 &&
        propertyAddress.town &&
        propertyAddress.county &&
        propertyAddress.postcode
    ) {
        return `${propertyAddress.line1} ${propertyAddress.line2}, ${propertyAddress.town}, ${propertyAddress.county}, ${propertyAddress.postcode}`;
    }
    if (
        propertyAddress.line1 &&
        propertyAddress.line2 &&
        propertyAddress.town &&
        propertyAddress.postcode
    ) {
        return `${propertyAddress.line1} ${propertyAddress.line2}, ${propertyAddress.town}, ${propertyAddress.postcode}`;
    }
    if (
        propertyAddress.line1 &&
        propertyAddress.line2 &&
        propertyAddress.county &&
        propertyAddress.postcode
    ) {
        return `${propertyAddress.line1} ${propertyAddress.line2}, ${propertyAddress.county}, ${propertyAddress.postcode}`;
    }
    if (
        propertyAddress.line1 &&
        propertyAddress.line2 &&
        propertyAddress.postcode
    ) {
        return `${propertyAddress.line1} ${propertyAddress.line2}, ${propertyAddress.postcode}`;
    }
    return '';
};
